import clsx from "clsx";
import React, { FC, ReactNode } from "react";

type Props = {
  onClick: () => void;
  isActive: boolean;
  children: ReactNode;
};

export const TextButton: FC<Props> = ({ onClick, isActive, children }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "whitespace-nowrap",
        isActive ? "font-bold cursor-auto text-[#1c77ff]" : "font-normal hover:underline cursor-pointer text-[#888888]"
      )}
    >
      {children}
    </button>
  );
};
